// --------------------------------------------------------------
// Created On: 2024-05-14
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-18
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import SearchModal from "../SearchModal/SearchModal";
import styles from "./DashboardCard.module.scss";

// Card on the dashboard used to move to a new page.
export default function DashboardCard(props: Props): Component {
  const [showSearchModal, setShowSearchModal] = useState<boolean>(false);
  const navigate = useNavigate();

  // Either opens a modal or navigates to a different page depending on the card name.
  function handleClick(name: string): void {
    if (name.toUpperCase() === "START ORDER") {
      setShowSearchModal(true);
    } else {
      navigate(props.url);
    }
  }

  return (
    <Fragment>
      <div className="col-12 col-md-4 my-2">
        <button className={`${styles.body} btn btn-light btn-lg`} onClick={() => handleClick(props.name)}>
          <div className="row">
            <div className="col-12 ">
              <i className={`fa fa-4x ${props.icon}`} />
            </div>
            <div className="col-12">{props.name}</div>
          </div>
        </button>
      </div>

      <SearchModal showModal={showSearchModal} onClose={() => setShowSearchModal(false)} />
    </Fragment>
  );
}

interface Props {
  icon: string;
  name: string;
  url: string;
}
